export default __webpack_public_path__ + "static/media/mongo.4d0524e8.svg";